import { Form, useNavigate } from 'react-router';
import { useRef } from 'react'

import { useClickOutside } from '~/hooks/useClickOutside'

import { UserSession } from '~/data/auth.server'
import { City, CITY_LABELS } from '~/utils'

import Cancel from '~/icons/cancel.svg'
import WhiteLogo from '~/icons/whiteLogo.svg'
import LocationWhite from '~/icons/locationWhite.svg'

const MobileModal = ({
  user,
  city,
  openLocationModal,
  onClose,
}: {
  user?: UserSession | null
  city?: City
  openLocationModal: () => void
  onClose: () => void
}) => {
  const navigate = useNavigate()

  const modalRef = useRef<HTMLDivElement>(null)
  useClickOutside(modalRef, onClose)

  return (
    <div
      ref={modalRef}
      className='md:hidden flex h-screen bg-magenta flex-col justify-between'
    >
      <div className='flex flex-col gap-5 pt-7'>
        <div className='flex justify-end px-4'>
          <button onClick={() => onClose()}>
            <img src={Cancel} alt='cancel' />
          </button>
        </div>
        <div className='flex justify-center'>
          <img src={WhiteLogo} alt='logo' />
        </div>
        <div className='flex flex-col gap-4 text-white'>
          <button
            onClick={() => {
              onClose()
              navigate('/events/search')
            }}
          >
            Events
          </button>
          <button
            onClick={() => {
              onClose()
              navigate('/artists/search')
            }}
          >
            Artists
          </button>
          <button
            onClick={() => {
              onClose()
              navigate('/hosts/search')
            }}
          >
            Hosts
          </button>
          {user && (
            <button
              onClick={() => {
                onClose()
                navigate('/events/feed')
              }}
            >
              My Feed
            </button>
          )}
          {user && (
            <>
              <button
                onClick={() => {
                  onClose()
                  navigate(
                    user.artist
                      ? `/artists/${user.artist.profileId}`
                      : 'artists/create'
                  )
                }}
              >
                Artist profile
              </button>
              <button
                onClick={() => {
                  onClose()
                  navigate(
                    user.host ? `/hosts/${user.host.profileId}` : 'hosts/create'
                  )
                }}
              >
                Host profile
              </button>
              <a className='text-center' href='/recipient/details'>
                Bank details
              </a>
            </>
          )}
        </div>
        {/* Login/Logout buttons */}
        <div className='flex flex-col gap-4 items-center text-white'>
          {user ? (
            <Form action='/auth/logout' method='post'>
              <button className='py-2.5 px-10 rounded-button text-white border border-white'>
                Logout
              </button>
            </Form>
          ) : (
            <>
              <button
                className='py-2.5 px-10 rounded-button text-white border border-white'
                onClick={() => {
                  onClose()
                  navigate('/auth/login')
                }}
              >
                Login
              </button>
              <button
                className='py-2.5 px-10 rounded-button text-magenta bg-white'
                onClick={() => {
                  onClose()
                  navigate('/auth/signup')
                }}
              >
                Sign up
              </button>
            </>
          )}
        </div>
      </div>
      {/* User avatar */}
      <div className='p-5 flex justify-end mb-28'>
        <div className='flex gap-8 w-full justify-end items-center'>
          <button
            className='flex gap-2 text-white underline items-center'
            onClick={() => {
              onClose()
              openLocationModal()
            }}
          >
            <img src={LocationWhite} alt='location_icon' />
            {city ? CITY_LABELS[city] : CITY_LABELS.melbourne_australia}
          </button>
          {user && (
            <div className='bg-orange h-userAvatar w-userAvatar rounded-circle flex justify-center items-center'>
              {user.name[0].toUpperCase()}
            </div>
          )}
        </div>
      </div>
    </div>
  )
}

export default MobileModal
